import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

import { IFileInfo, Dictionary } from '../../models/models';

@Component({
  selector: 'app-check-box-list',
  templateUrl: './check-box-list.component.html',
})
export class CheckBoxListComponent {
  @Input() allowMultipleSelection: boolean = false;

  @Input() isRequired: boolean = false;

  @Input() headerText: string = '';

  @Input() itemsSource: Dictionary[] = [];

  @Input() selectedItems: Dictionary[] = [];

  @Output() selectedItemsChange = new EventEmitter<Dictionary[]>();


  public itemIsChecked(item: Dictionary) {
    return this.selectedItems && this.selectedItems.indexOf(item) !== -1;
  }

  public onChangeEvent(event: Event, item: Dictionary) {
    if (!this.selectedItems || !this.allowMultipleSelection) {
      this.selectedItems = [];
    }

    var isChecked = (event.target as HTMLInputElement).checked;
    if (isChecked) {
      this.selectedItems.push(item);
    }
    else {
      var index = this.selectedItems.indexOf(item);
      if (index !== -1) {
        this.selectedItems.splice(index, 1);
      }
    }

    this.selectedItemsChange.emit(this.selectedItems);
  }
}
